<div class="modal-header">
  <h4 class="modal-title h5" translate>API endpoint configuration</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form (ngSubmit)="onSave()" [formGroup]="form">
  <div class="modal-body">
    <div class="form-row">

      <!-- URL -->
      <div class="col-12">
        <div class="form-group">
          <label for="url" translate>URL</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-url" [innerText]="baseUrl"></span>
            </div>
            <input (change)="onUrlNameChange()" [disabled]="!superOrTechAdmin"
              [ngClass]="{ 'is-invalid': submitted && f.url.errors }" class="form-control"
              formControlName="url"
              id="url" name="url" type="text">

              @if (submitted && f.url.errors) {
                <div class="invalid-feedback">
                  @if (f.url.errors.required) {
                    <span translate>Valid API-URL required</span>
                  }
                  @if (f.url.errors.used) {
                    <span translate>This URL is already in use</span>
                  }
                  @if (f.url.errors.pattern) {
                    <span translate>The specified endpoint may only contain letters [a-z] and numbers [0-9].</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <!-- ACTION -->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="action" translate>Action</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            @if (isLoadingAvailableTriggerQueries) {
              <span class="fa-solid fa-spinner fa-spin"></span>
            }
            <ng-select [disabled]="!superOrTechAdmin" [items]="availableTriggerQueries"
              [ngClass]="{ 'is-invalid': submitted && f.action.errors }"
              bindLabel="name" bindValue="id" formControlName="action" id="action">
            </ng-select>
            <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.action.errors }" class="form-control"
              id="selectedActionType" type="text">
              @if (submitted && f.action.errors) {
                <div class="invalid-feedback">
                  @if (f.action.errors.required) {
                    <span translate>Action required</span>
                  }
                </div>
              }
            </div>
          </div>

          <!-- MAX REQUESTS PER HOUR -->
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="maxRequestsPerHour" translate>Max Requests per Hour</label>
              <scitis-required-field-indicator></scitis-required-field-indicator>
              <div class="input-group">
                <input [ngClass]="{ 'is-invalid': submitted && f.maxRequestsPerHour.errors }"
                  class="form-control"
                  formControlName="maxRequestsPerHour" id="maxRequestsPerHour" min="1" name="maxRequestsPerHour"
                  step="1"
                  type="number">
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="modal-footer-inner">
            <div class="row align-items-center flex-fill">
              <div class="col">
                <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
              </div>
              <div class="col-auto">
                <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
                  <span translate>Cancel</span>
                </button>
                <button [disabled]="isDisabledSaveBtn || !superOrTechAdmin" class="btn btn-primary" type="submit">
                  <span translate>Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>

      </form>
